module.exports = __webpack_public_path__ + "img/light_yellow.936ab6a.png";